export default "__VITE_ASSET__Dp7VLmiw__"